import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { StepCompletionExecution } from 'app/models/step-completion-execution';
import { WorkflowTemplate } from 'app/models/workflow-template';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { UserService } from 'app/services/user.service';
import { WorkflowExecutionService } from 'app/services/workflow-execution.service';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { FeatureTrialLockModalComponent } from 'app/views/feature-trial-lock-modal/feature-trial-lock-modal.component';
import { MDBModalService, ToastService } from 'ng-uikit-pro-standard';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-initial-submission',
  templateUrl: './initial-submission.component.html',
  styleUrls: ['./initial-submission.component.scss']
})
export class InitialSubmissionComponent implements OnInit {

  workflowExecFormGroup: FormGroup;
  isLoading: boolean = false;
  currentWorkflowTemplate: WorkflowTemplate = null;

  constructor(public workflowExecutionService: WorkflowExecutionService, private workflowTemplateService: WorkflowTemplateService,
              private formBuilder: FormBuilder, private validationHandler: ValidationHandler,
              private activatedRoute: ActivatedRoute, private ecoDocsTitleService: EcoDocsTitleService,
              private toastService: ToastService, private router: Router, private userService: UserService,
              private modalService: MDBModalService) {

  }

  ngOnInit(): void {
    this.ecoDocsTitleService.setTitle( 'Start Workflow', false );

    this.isLoading = true;
    this.workflowTemplateService.getById(this.activatedRoute.snapshot.params['id'], true).pipe(finalize(() => this.isLoading = false)).subscribe(res => {
      this.currentWorkflowTemplate = res;

      this.workflowExecFormGroup = this.formBuilder.group({
        name: ['', [Validators.maxLength(255)]],
        workflow_template_id: [this.currentWorkflowTemplate.id, Validators.required]
      });
    });

  }

  onSubmit(stepCompletionExecution: StepCompletionExecution): void {
    if (!this.userService.currentUserValue.subscription_status.is_subscribed &&
      !this.userService.currentUserValue.subscription_status.trial_active) {
        this.modalService.show(FeatureTrialLockModalComponent, {
          ignoreBackdropClick: true,
          backdrop: false,
          animated: true,
          containerClass: 'modal fade',
          class: 'modal-dialog modal-danger modal-notify',
          data: {
          }
        });
        return;
    }

    this.validationHandler.onSubmitCheck(this.workflowExecFormGroup);
    if (!this.workflowExecFormGroup.valid) {
      return;
    }

    this.isLoading = true;
    this.workflowExecutionService.submitExecution(this.workflowExecFormGroup.value, stepCompletionExecution).pipe(finalize(() => {
      this.isLoading = false;
    })).subscribe(() => {
      this.toastService.success('Workflow started!');
      this.router.navigate(['/workflows/status']);
    }, () => {
      this.toastService.error('Error while starting workflow!');
    });;
  }
}
